var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// - Import react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from '@material-ui/core/Avatar';
/**
 * Create component class
 */
var UserAvatarComponent = /** @class */ (function (_super) {
    __extends(UserAvatarComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function UserAvatarComponent(props) {
        var _this = _super.call(this, props) || this;
        // Defaul state
        _this.state = {};
        return _this;
        // Binding functions to `this`
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    UserAvatarComponent.prototype.render = function () {
        var _a = this.props, fileName = _a.fileName, fullName = _a.fullName, style = _a.style, size = _a.size, onClick = _a.onClick;
        return (React.createElement("div", { style: { display: 'inherit' } }, (fileName && fileName !== '' && fileName !== 'noImage')
            ? (React.createElement(Avatar, { src: fileName ? fileName : ' ', style: __assign({}, style, { backgroundColor: '#ffffff', width: size || 36, height: size || 36 }), onClick: onClick }))
            : (React.createElement(Avatar, { style: __assign({}, style, { backgroundColor: 'black', width: size || 36, height: size || 36 }), onClick: onClick }, fullName ? fullName.slice(0, 1) : ''))));
    };
    UserAvatarComponent.propTypes = {
        /**
         * Use for getting url address from server
         */
        fileName: PropTypes.string,
        /**
         * User full name
         */
        fullName: PropTypes.string,
        /**
         * Avatar style
         */
        style: PropTypes.object,
        /**
         * Avatar size
         */
        size: PropTypes.number,
        /**
         * Trigger on touch tap
         */
        onClick: PropTypes.func
    };
    return UserAvatarComponent;
}(Component));
export { UserAvatarComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    return {
        avatarURL: state.getIn(['imageGallery', 'imageURLList']),
        imageRequests: state.getIn(['imageGallery', 'imageRequests'])
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(UserAvatarComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/userAvatar/UserAvatarComponent.tsx
// module id = 1099
// module chunks = 0 1 2 3 4 5 6 7 10